import { render, staticRenderFns } from "./Topics.vue?vue&type=template&id=0bf2eab4&"
import script from "./Topics.vue?vue&type=script&lang=js&"
export * from "./Topics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports